/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarCardHeader\CarCardHeader.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 20th 2023
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Styles from "Content/Car/CarCardHeader/CarCardHeader.module.css";
import { useEffect, useState } from 'react';
import { IconSubSectionType } from './CarCardHeader.type';
import Config from "Config/Config";

function CarCardHeader (props: IconSubSectionType) {
    const [iconToDisplay, setIconSubSection] = useState("");

    useEffect(() => {
        if (iconToDisplay == "")
            switch (props.IconSubSection) {
                case "BREAK":
                    setIconSubSection("/IconsCarSubSection/BREAK_V1.svg");
                    break;
                case "CITYCAR":
                    setIconSubSection("/IconsCarSubSection/CITADINE_V1.svg");
                    break;
                case "SUV":
                    setIconSubSection("/IconsCarSubSection/SUV_V1.svg");
                    break;
                case "UTILITY":
                        setIconSubSection("/IconsCarSubSection/VU_V1.svg");
                        break;
                case "SEDAN":
                    setIconSubSection("/IconsCarSubSection/BERLINE_V1.svg");
                    break;
                default:
                    break;
            }
    }, [iconToDisplay]);

    return (
        <div className={`${Styles.label_car}`}>
            <div className={`${Styles.left_part}`}>
                {iconToDisplay !== "" ? <img className={`${Styles.icon_sub_car}`} src={iconToDisplay} alt="Car Icon"/> : null }
                <p className="m-0">{Config.COMMON.COMPANY_NAME}</p>
            </div>
        </div>
    );
}

export default CarCardHeader;
